module.exports = __webpack_public_path__ + "static/media/xray.f8c802b1.png";